<template>
  <button
    type="button"
    :disabled="disabled"
    class="bg-surface-canvas/90 border dark:bg-surface-canvas/[0.03] duration-200 flex gap-3 group items-center overflow-hidden px-3 py-3 relative rounded-xl shadow-selectable-card text-left transition-all w-full"
    :class="[
      checked && !disabled
        ? 'border-primary/35 bg-[image:var(--surface-selectable-card-selected)] shadow-selectable-card-selected dark:border-primary/40 dark:bg-[image:var(--surface-selectable-card-selected-dark)]'
        : 'border-border-level-200/90 dark:border-border-inverse/10',
      disabled
        ? 'cursor-not-allowed opacity-60'
        : 'cursor-pointer hover:border-primary/25 hover:bg-primary/[0.03] hover:shadow-selectable-card-hover dark:hover:border-primary/30 dark:hover:bg-primary/[0.08]'
    ]"
    @click="handleToggle"
  >
    <div
      v-if="checked"
      class="-right-8 -top-8 absolute bg-primary/15 blur-2xl h-16 pointer-events-none rounded-full w-16"
    />

    <div
      class="border flex flex-shrink-0 h-5 items-center justify-center relative rounded-md transition-all w-5"
      :class="[
        checked
          ? 'border-primary bg-primary shadow-control-selected'
          : 'border-border-level-300 bg-surface-canvas dark:border-border-level-600 dark:bg-surface-clear'
      ]"
    >
      <CheckIcon
        v-if="checked"
        class="size-3.5 text-content-inverse"
      />
    </div>

    <div class="flex-1 min-w-0 relative">
      <div class="flex gap-2 items-center justify-between">
        <div class="flex gap-1.5 items-center min-w-0">
          <p class="dark:text-content-inverse font-medium text-content-level-900 text-sm truncate">
            {{ title }}
          </p>

          <slot name="titleBadge" />
        </div>

        <slot name="badge" />
      </div>

      <p
        v-if="description"
        class="break-words dark:text-content-level-400 leading-5 text-content-level-500 text-xs whitespace-normal"
      >
        {{ description }}
      </p>
    </div>
  </button>
</template>

<script setup lang="ts">
import { CheckIcon } from '@heroicons/vue/20/solid'

interface Props {
  /** Whether the card is selected. */
  checked: boolean
  /** Card heading. */
  title: string
  /** Optional supporting description. */
  description?: string
  /** Whether the card is unavailable for selection. */
  disabled?: boolean
}

withDefaults(defineProps<Props>(), {
  description: ''
})

const emit = defineEmits<{
  toggleRequested: []
}>()

defineSlots<{
  badge?: () => unknown
  titleBadge?: () => unknown
}>()

const handleToggle = () => {
  emit('toggleRequested')
}
</script>
